/*! Copyright (c) Safe As Milk. All rights reserved. */

function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };

    rootElement.querySelectorAll(".rte table").forEach((table) => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;

        const tableWrapper = document.createElement("div");

        tableWrapper.classList.add(
            "js-theme-utility-rte-table-wrap"
        );

        tableWrapper.setAttribute(
            "style",
            "overflow:auto;-webkit-overflow-scrolling:touch"
        );

        wrapTable(table, tableWrapper);
    });
};

/*
 * Homepage performance optimization
 *
 * RTE table wrapping is not required for the homepage critical render.
 * Keep the function synchronously available for dynamic callers, but move
 * only the homepage's initial full-document scan outside the critical path.
 *
 * Interior templates preserve the theme's original synchronous behavior.
 */
const isHomepage =
    document.body?.classList.contains("template-index") === true;

if (isHomepage) {
    const scheduleRteTableWrap = () => {
        window.theme.wrapRteTables();
    };

    if ("requestIdleCallback" in window) {
        requestIdleCallback(
            scheduleRteTableWrap,
            { timeout: 4000 }
        );
    } else {
        /*
         * Older Safari fallback.
         *
         * A short timeout keeps this noncritical scan away from the
         * immediate DOMContentLoaded workload instead of moving it directly
         * into that already-busy execution window.
         */
        setTimeout(scheduleRteTableWrap, 1200);
    }
} else {
    /*
     * Preserve existing behavior on product, article, page and other
     * templates where RTE tables may actually be part of visible content.
     */
    window.theme.wrapRteTables();
}


/*
 * scrollend compatibility
 *
 * The custom homepage implementation does not require the scrollend
 * polyfill during initial page execution, so don't introduce another
 * module into the mobile homepage dependency graph.
 *
 * Interior templates retain the existing compatibility behavior.
 */
const scrollEndSupported =
    typeof window === "undefined"
        ? true
        : "onscrollend" in window;

if (!scrollEndSupported && !isHomepage) {
    import("scrollyfills");
}

//# sourceMappingURL=global.js.map